export enum CurrencyPerUnit {
  NOK_PER_KG = 'nokPerKg',
  USD_PER_TON = 'usdPerTon',
}

export enum Currency {
  NOK = 'nok',
  USD = 'usd',
}

export interface ScenarioFinancialData {
  scenarioId: string;
  treatmentsPerCage: number;
  costOfSingleTreatment: number;
  currencyPerUnit: CurrencyPerUnit;
  currency: Currency;
  productionCostPerWeekPerCage: number;
  harvestCostPerKg: number;
  smoltCostPerSingleSmolt: number;
  salesPricePerKgUnder1Kg: number;
  salesPricePerKg1To2Kg: number;
  salesPricePerKg2To3Kg: number;
  salesPricePerKg3To4Kg: number;
  salesPricePerKg4To5Kg: number;
  salesPricePerKg5To6Kg: number;
  salesPricePerKgOver6Kg: number;
}
